import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { paymentService } from '../services/paymentService';
import '../styles/Payment.css';

function TamaraCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [processing, setProcessing] = useState(true);
  const [message, setMessage] = useState('جاري معالجة عملية الدفع...');

  useEffect(() => {
    const handleTamaraCallback = async () => {
      const status = searchParams.get('status');
      const bookingId = searchParams.get('booking');

      // Get pending payment info from localStorage
      const pendingPaymentStr = localStorage.getItem('pendingTamaraPayment');

      if (!pendingPaymentStr || !bookingId) {
        setMessage('معلومات الدفع غير موجودة');
        setProcessing(false);
        setTimeout(() => navigate('/'), 3000);
        return;
      }

      const pendingPayment = JSON.parse(pendingPaymentStr);

      try {
        if (status === 'success') {
          setMessage('تمت عملية الدفع بنجاح! جاري التحقق من الحالة...');

          // Verify payment status with Tamara
          const verificationResult = await paymentService.verifyTamaraPayment(pendingPayment.orderId);

          if (verificationResult.success && verificationResult.status === 'approved') {
            // Authorize the order
            const authResult = await paymentService.authorizeTamaraOrder(pendingPayment.orderId);

            if (authResult.success) {
              // Clear pending payment info
              localStorage.removeItem('pendingTamaraPayment');
              localStorage.removeItem('bookingData');

              // Navigate to success page
              navigate(`/payment-success?booking=${bookingId}`);
            } else {
              setMessage('فشل في تأكيد الطلب. يرجى التواصل مع الدعم.');
              setProcessing(false);
            }
          } else {
            setMessage('الدفع قيد المعالجة. يرجى الانتظار...');

            // Try to authorize after a delay
            setTimeout(async () => {
              try {
                const authResult = await paymentService.authorizeTamaraOrder(pendingPayment.orderId);
                if (authResult.success) {
                  localStorage.removeItem('pendingTamaraPayment');
                  localStorage.removeItem('bookingData');
                  navigate(`/payment-success?booking=${bookingId}`);
                }
              } catch (error) {
                console.error('Authorization retry error:', error);
              }
            }, 3000);
          }
        } else if (status === 'failure' || status === 'cancel') {
          setMessage(status === 'cancel' ? 'تم إلغاء عملية الدفع' : 'فشلت عملية الدفع');
          setProcessing(false);

          // Clear pending payment info
          localStorage.removeItem('pendingTamaraPayment');

          // Navigate back to payment page after 3 seconds
          setTimeout(() => navigate('/payment'), 3000);
        }
      } catch (error) {
        console.error('Tamara callback error:', error);
        setMessage('حدث خطأ في معالجة الدفع. يرجى المحاولة مرة أخرى.');
        setProcessing(false);
        setTimeout(() => navigate('/payment'), 3000);
      }
    };

    handleTamaraCallback();
  }, [searchParams, navigate]);

  return (
    <div className="payment-page">
      <div className="payment-container">
        <div className="payment-loading-container">
          <div className="payment-loading-content">
            {processing && (
              <div className="payment-spinner">
                <div className="spinner-circle"></div>
                <div className="spinner-circle-2"></div>
                <div className="spinner-circle-3"></div>
              </div>
            )}
            <div className="loading-text">
              <h3>{message}</h3>
              {processing && <p>يرجى عدم إغلاق الصفحة</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TamaraCallback;